import React, {useState} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Routes,
    Navigate,
    Redirect,
} from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';


import AuctionItemPreview from './pages/AuctionItemPreview';
import AuctionItemPreviewDets from './pages/AuctionItemPreviewDets';
import ErrorPage from './pages/ErrorPage';
import AuctionItemMgmt from './pages/AuctionItemMgmt';
import AuctionItemMgmtCustomLayouts from './pages/AuctionItemMgmtCustomLayouts';
import AuctionItemCreation from './pages/AuctionItemCreation';
import AppComponents from './pages/AppComponents';
import DashBoard from './pages/DashBoard';
import AlertsPage from './pages/AlertsPage';
import LogInPage from './pages/LogInPage';
import ForgotPwPage from './pages/ForgotPwPage';
import RegistrationPage from './pages/RegistrationPage';
import AuthChangePwPage from './pages/AuthChangePwPage';
import AuthReqMFACodePage from './pages/AuthReqMFACodePage';
import AuthEnterMFACodePage from './pages/AuthEnterMFACodePage';
import ProtectedRoute from './components/ProtectedRoute';



import { FooterSimple}  from './components/FooterSimple';
//import LandingPage from './pages/LandingPage';

const App = () => {
    //<Route exact path="/LandingPage" element={<LandingPage />} />
    let isLoggedIn = localStorage.getItem('loggedIn');

    return (
        <>
            <Router>
                <Routes>
                    <Route path="*" element={<ErrorPage />} />
                    <Route exact path="/auth/login" element={<LogInPage />} />
                    <Route exact path="/auth/register" element={<RegistrationPage />} />
                    <Route exact path="/auth/forgotpw" element={<ForgotPwPage />} />
                    
                    <Route path="/" element={<ProtectedRoute />}>
                        <Route exact path="/auctionitempreview" element={<AuctionItemPreview />} />
                        <Route exact path="/itemdets" element={<AuctionItemPreviewDets />} />
                        <Route exact path="/customlayouts" element={<AuctionItemMgmtCustomLayouts />} />
                        <Route exact path="/auctioncreation" element={<AuctionItemCreation />} />
                        <Route exact path="/auctionmgmt" element={<AuctionItemMgmt />} />
                        <Route exact path="/appcomponents" element={<AppComponents />} />
                        <Route exact path="/auctioneer/dashboard" element={<DashBoard />} />
                        <Route exact path="/alerts" element={<AlertsPage />} />
                        <Route exact path="/auth/resetpw" element={<AuthChangePwPage />} />
                        <Route exact path="/auth/initMFA" element={<AuthReqMFACodePage />} />
                        <Route exact path="/auth/enterMFA" element={<AuthEnterMFACodePage />} />
                    </Route>
                    <Route exact path="/" element={<Navigate replace to="/auth/login" />} />
                </Routes>
            </Router>
        </>
    )
}

export default App
